import moment from "moment";
import { CarbonCopyInput } from "../carbon-copy";
import { UserMode } from "../enums";
import { TicketDocumentResult } from "../ticket-document";

export class TicketCommentResult {
    public id: number = 0;
    public comment: string = '';
    public dateTime: moment.Moment = moment(moment.now(), 'YYYY-MM-DD').utc(false);
    public isPublic: boolean = false;
    public ticketId: number = 0;
    public userId: number = 0;
    public userFullName: string = '';
    public userMode: UserMode = UserMode.CustomerEmployee;
    public personalPictureFileName: string = '';
    public isDeleted: boolean = false;
    public carbonCopies: Array<CarbonCopyInput> = [];
    public documents: Array<TicketDocumentResult> = [];
}
